import axios from '@utils/http'

export const state = {}

export const getters = {}

export const mutations = {}

export const actions = {
  getApprovers({ commit, dispatch, getters }) {
    return axios.get('/api/approverWorkflows').then(response => {
      const fields = response.data
      return fields
    })
  },

  createApprover({ commit, dispatch, getters }, approver = {}) {
    return axios.post('/api/approverWorkflows', approver).then(response => {
      const fields = response.data
      return fields
    })
  },

  updateApproverOrder(
    { commit, dispatch, gettings },
    { workflowId, approvers } = {}
  ) {
    return axios.post(
      `/api/approverWorkflows/${workflowId}/updateWorkflowOrder`,
      approvers
    )
  },

  getApprover({ commit, dispatch, gettings }, { workflowId } = {}) {
    return axios.get(`/api/approverWorkflows/${workflowId}`)
  },

  deleteApprover({ commit, dispatch, gettings }, approver = {}) {
    return axios.delete(`/api/approverWorkflows/${approver.id}`)
  },

  addApproverToWorkflow({ commit, dispatch, getters }, { signoff } = {}) {
    return axios.post(
      `/api/approverWorkflows/${signoff.workflowId}/addSignoff`,
      signoff
    )
  },

  deleteSignoff({ commit, dispatch, getters }, { signoffId } = {}) {
    return axios.delete(`/api/workflowSignoffs/${signoffId}`)
  },
}
